import { Alpha3Code } from 'i18n-iso-countries'

import {
  MonetaryVerificationStatus,
  MonetaryVerificationCheckStatus,
  MonetaryVerificationDetails,
  CheckType,
  MonetaryDonationVerificationCheck
} from '@percent/admin-dashboard/api/actions/monetaryVerifications/monetaryVerifications.types'
import { OrganisationTypes } from '@percent/domain/verifications'

export const mockMonetaryVerifications = {
  data: [
    {
      id: '1',
      status: MonetaryVerificationStatus.EXPIRED,
      organisationId: '1',
      organisationDetails: {
        name: 'John Doe organization',
        countryCode: 'GBR' as Alpha3Code
      },
      createdAt: '2024-01-30T10:30:00.000Z',
      updatedAt: '2024-01-30T14:45:00.000Z',
      rejectedAt: null,
      approvedAt: null,
      partner: {
        name: 'John Doe'
      },
      organisation: {
        name: 'John Doe organization',
        countryCode: 'GBR' as Alpha3Code
      }
    },
    {
      id: '2',
      status: MonetaryVerificationStatus.PENDING,
      organisationId: '2',
      organisationDetails: {
        name: 'Acme Corporation',
        countryCode: 'USA' as Alpha3Code
      },
      createdAt: '2024-01-15T09:00:00.000Z',
      updatedAt: '2024-01-20T11:30:00.000Z',
      rejectedAt: null,
      approvedAt: null,
      partner: {
        name: 'Jane Smith'
      }
    },
    {
      id: '3',
      status: MonetaryVerificationStatus.APPROVED,
      organisationId: '3',
      organisationDetails: {
        name: 'Global Foundation',
        countryCode: 'CAN' as Alpha3Code
      },
      createdAt: '2024-01-10T08:15:00.000Z',
      updatedAt: '2024-01-25T16:20:00.000Z',
      rejectedAt: null,
      approvedAt: '2024-01-25T16:20:00.000Z',
      partner: {
        name: 'Mike Johnson'
      }
    },
    {
      id: '4',
      status: MonetaryVerificationStatus.REJECTED,
      organisationId: '4',
      organisationDetails: {
        name: 'Tech Solutions Ltd',
        countryCode: 'AUS' as Alpha3Code
      },
      organisation: {
        name: 'Tech Solutions Ltd',
        countryCode: 'AUS' as Alpha3Code
      },
      createdAt: '2024-01-05T14:45:00.000Z',
      updatedAt: '2024-01-18T10:15:00.000Z',
      rejectedAt: '2024-01-18T10:15:00.000Z',
      approvedAt: null,
      partner: {
        name: 'Sarah Wilson'
      }
    },
    {
      id: '5',
      status: MonetaryVerificationStatus.PENDING,
      organisationId: '5',
      organisationDetails: {
        name: 'Green Energy Co',
        countryCode: 'DEU' as Alpha3Code
      },
      createdAt: '2024-01-22T12:00:00.000Z',
      updatedAt: '2024-01-22T12:00:00.000Z',
      rejectedAt: null,
      approvedAt: null,
      partner: {
        name: 'David Brown'
      }
    }
  ],
  object: 'monetary_donation_verification',
  totalResults: 5,
  pageNumber: 1,
  pageSize: 25,
  _links: {
    current: 'https://.../v1/...?cursor=eyJ2Ijox...N3AifQ%3D%3D',
    next: 'https://.../v1/...?cursor=eyJ2Ijox...N3AifQ%3D%3D',
    prev: 'https://.../v1/...?cursor=eyJ2Ijox...N3AifQ%3D%3D'
  }
}

export const mockMonetaryVerificationDetails: MonetaryVerificationDetails = {
  id: '1',
  configurationId: 'config-67890-fghij',
  organisationId: '1',
  organisationDetails: {
    id: '1',
    name: 'John Doe organization',
    displayName: null,
    description: '',
    registryId: '1',
    registry: 'John Doe',
    countryCode: 'GBR',
    type: OrganisationTypes.Nonprofit,
    logo: null,
    images: [],
    website: '',
    address: null,
    postcode: null,
    registrationDate: null,
    registrationActive: true,
    currencyCode: 'GBP',
    trustees: null,
    claimedAt: null,
    createdAt: '2024-01-30T10:30:00.000Z',
    types: [OrganisationTypes.Nonprofit]
  },
  status: MonetaryVerificationStatus.PENDING,
  createdAt: '2024-01-30T10:30:00.000Z',
  updatedAt: '2024-01-30T14:45:00.000Z',
  resolvedAt: null,
  validationSubmissionId: 'vs-33333-uvwxy',
  partnerName: 'partnerName',
  contactDetails: [
    {
      lastName: 'Doe',
      firstName: 'John',
      primaryEmail: 'john.doe@example.com'
    }
  ],
  checks: [
    {
      type: CheckType.VALIDATION_SUBMISSION,
      status: MonetaryVerificationCheckStatus.SUCCEEDED
    }
  ]
}

export const mockProfileDataCheck: MonetaryDonationVerificationCheck = {
  status: MonetaryVerificationCheckStatus.FAILED,
  reason: 'Profile data check failed'
}

export const mockUboCheck: MonetaryDonationVerificationCheck = {
  status: MonetaryVerificationCheckStatus.FAILED,
  reason: 'UBO check failed'
}

export const mockPaymentDetailsCheck: MonetaryDonationVerificationCheck = {
  status: MonetaryVerificationCheckStatus.FAILED,
  reason: 'Payment details check failed'
}

export const mockAdyenSpecificCheck: MonetaryDonationVerificationCheck = {
  status: MonetaryVerificationCheckStatus.FAILED,
  reason: 'Adyen specific check failed'
}
